const dic = JSON.parse(localStorage.dic);
export default {
  inject: {
    _mode: {
      from: 'mode',
      default: 'edit'
    }
  },
  computed: {
    mode() {
      return this._mode();
    },
    isEdit() {
      return this._mode() === 'edit';
    },
    isRead() {
      return this._mode() === 'read';
    }
  },
  filters: {
    optionsFilter(val, options, kN, vN, defV) {
      const vT = typeof val;
      if (vT === 'undefined' || val === null) {
        return defV || '';
      }
      if (!options) {
        if (Array.isArray(val)) {
          return val.join('、');
        }
        return val;
      }
      if (!options.length) {
        if (Array.isArray(val)) {
          return val.join('、');
        }
        return val;
      }
      const _key = kN || 'value';
      const _val = vN || 'label';
      if (Array.isArray(val)) {
        return val.map(item => options.find(it => it[_key] === item)[_val]).join('、');
      } else {
        return options.find(item => item[_key] === val)[_val] || defV || '';
      }
    },
    dateFilter(d, t = 'Y') {
      // .e.g 2025-01-14 00:00:00
      d = d || '';
      // 截取前10位
      if (t === 'Y') {
        return d.substring(0, 10);
      } else if (t === 'm') {
        return d.substring(0, 16);
      }
      return d;
    },
    lzDicFilter(val, dicN) {
      if (!dic) {
        return val;
      }
      let _dic = {};
      if (typeof dicN === 'object') {
        _dic = dicN;
      } else if (typeof dicN === 'string') {
        _dic = dic[dicN];
      }
      if (typeof _dic != 'undefined') {
        for (var code in _dic) {
          if (code == val) {
            return _dic[code] || '';
          }
        }
      } else {
        return '';
      }
    }
  },
  methods: {
    getOrgName(fromClassName, toClassName) {
      setTimeout(() => {
        const pEl = document.querySelector(fromClassName);
        if (pEl) {
          const cEl = pEl.querySelector('.ivu-select-selected-value');
          if (cEl) {
            document.querySelector(toClassName).innerText = cEl.innerText;
          }
        }
        return '';
      }, 500);
    }
  }
};
